import React, { Suspense } from 'react'
import PublicPageLoader from '../../component/Elements/publicPageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'
import { useSearchParams } from 'react-router-dom'

const Login = lazyWithRetry(() => import(/* webpackChunkName: "login" */'../../component/Login'))

const LoginPage = React.memo(() => {
	let [params] = useSearchParams()

	return (
		<Suspense fallback={<PublicPageLoader className="authPage" />}>
			<Login emailParam={params.get('email')}
						 companyIndexParam={params.get('company_index')}
						 orderId={params.get('orderId')}
						 lat={params.get('lat')} lon={params.get('lon')}
						 desktopDeviceId={params.get('desktopDeviceId')}/>
		</Suspense>
	)
})

LoginPage.displayName = 'LoginPage'
export default LoginPage
